import React, { useState } from 'react';
import PropTypes from 'prop-types';

const getPaymentStatusInfo = status => {
  switch (status) {
    case 1:
      return ['#D32F2F', 'UNPAID'];
    case 2:
      return ['orange', 'PENDING'];
    case 3:
      return ['#17C671', 'PAID'];
    default:
      return ['black', 'UNKNOWN'];
  }
};

const PaymentsTable = props => {
  const [openIndex, setOpenIndex] = useState(-1);

  const toggleRowOpen = index => () => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="profile-payments-container">
      <p className="profile-title">Payments history</p>
      {props.payments.length === 0 && (
        <p className="profile-payments-empty">You do not have any payments history yet</p>
      )}
      {props.payments.length > 0 && (
        <table className="payments-table">
          <thead>
            <tr>
              <th></th>
              <th>Date</th>
              <th>Client Name</th>
              <th>Total</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {props.payments.map((payment, i) => {
              const [statusColor, statusText] = getPaymentStatusInfo(3);
              let style = { cursor: 'pointer' };
              if (openIndex === i) {
                style = { ...style, borderBottom: 'none' };
              }
              return (
                <React.Fragment key={i}>
                  <tr className="hoverable" style={style} onClick={toggleRowOpen(i)}>
                    <td>{i + 1}</td>
                    <td>{payment.date}</td>
                    <td>{payment.client.name}</td>
                    <td className="is-bold">{payment.total} €</td>
                    <td>
                      <div className="is-flex align-items-center">
                        <div className="payment-status-icon" style={{ background: statusColor, marginTop: '-3px' }} />
                        <p className="is-bold ml-10px mt-5px">{statusText}</p>
                      </div>
                    </td>
                    <td>
                      {openIndex !== i && <img src="/img/icons/caret-down.svg" />}
                      {openIndex === i && <img src="/img/icons/caret-up.svg" />}
                    </td>
                  </tr>
                  {openIndex === i && (
                    <tr>
                      <td colSpan="6">
                        <p>
                          Client Name: <strong>{payment.client.name}</strong>
                        </p>
                        <p>
                          Client Address: <strong>{payment.client.address}</strong>
                        </p>
                        <table className="table is-bordered is-fullwidth is-small mt-20px">
                          <thead>
                            <tr>
                              <th className="cell-center" style={{ width: '25px' }}></th>
                              <th className="cell-center" style={{ width: '50px' }}>
                                Qty
                              </th>
                              <th className="cell-center" style={{ width: '50px' }}>
                                Price
                              </th>
                              <th className="cell-center" style={{ width: '50px' }}>
                                Total
                              </th>
                              <th className="cell-center" style={{ width: '50px' }}>
                                Rate
                              </th>
                              <th className="cell-center">Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {payment.items.map((item, itemIndex) => (
                              <tr key={itemIndex}>
                                <td className="cell-center">{itemIndex + 1}</td>
                                <td className="cell-center">{item.count}</td>
                                <td className="cell-center">{item.price}</td>
                                <td className="cell-center">{item.total}</td>
                                <td className="cell-center">{item.rate}</td>
                                <td>{item.description}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

PaymentsTable.propTypes = {
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      total: PropTypes.number.isRequired,
      client: PropTypes.shape({
        name: PropTypes.string.isRequired,
        address: PropTypes.string.isRequired,
      }).isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          count: PropTypes.number.isRequired,
          description: PropTypes.string.isRequired,
          price: PropTypes.number.isRequired,
          rate: PropTypes.number.isRequired,
        }),
      ),
    }),
  ).isRequired,
};

export default PaymentsTable;
